import api from '@/api/wallet';

const wallet = {
  namespaced: true,

  state: {
    data: null,
  },

  mutations: {
    setWallet(state, data) {
      state.data = data;
    },
  },

  actions: {
    async getWallet({ commit }) {
      const response = await api.getWallet();
      const { success, data } = response;

      if (success) {
        commit('setWallet', data);
      }

      return { success };
    },

    async updateWalletSettings({ commit }, payload) {
      const response = await api.updateWalletSettings(payload);
      const { success, data } = response;

      if (success) {
        commit('setWallet', data);
      }

      return { success };
    },

    async createWallet({ commit }) {
      const response = await api.createWallet();
      const { success, data } = response;

      if (success) {
        commit('setWallet', data);
      }

      return { success };
    },
  },
};

export default wallet;
